import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { Observable } from "rxjs";
import { constants } from "../constants";
import { MailTemplate } from "../models/mail-template.model";

@Injectable({ providedIn: 'root' })
export class MailTemplateService {

    private static readonly MAIL_TEMPLATE_URL = `${constants.BASE_URL}/mail-template`;

    constructor(private http: HttpClient) { }

    get(code: string): Observable<MailTemplate> {
        return this.http.get<MailTemplate>(`${MailTemplateService.MAIL_TEMPLATE_URL}/${code}`);
    }

    update(template: string, code: string): Observable<MailTemplate> {
        return this.http.put<MailTemplate>(`${MailTemplateService.MAIL_TEMPLATE_URL}/${code}`, template);
    }

}